import React from 'react';

import styled from '@emotion/styled';
import theme from '../utils/theme';

import { laptopQuery, desktopQuery, mobileQuery } from '../utils/mediaqueries';

import { Link } from 'gatsby';
import Icon from './Icon';

const Wrapper = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    textDecoration: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    textOverflow: 'ellipsis',
    height: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flex: 1,
    width: '100%',
    textAlign: 'center',
    transition: 'background 500ms',

    '&:hover': {
      background: theme.colors.lightOrangeBackground,
    },

    [laptopQuery]: {
      borderBottom: `1px solid ${theme.colors.darkBlue}`,
      borderRight: `1px solid ${theme.colors.darkBlue}`,
    },

    [desktopQuery]: {
      borderBottom: `1px solid ${theme.colors.darkBlue}`,
      borderRight: `1px solid ${theme.colors.darkBlue}`,
    },

    '&.active': {
      backgroundColor: theme.colors.orangeBackground,
    },
  },
  props => ({
    backgroundColor: props.highlight
      ? theme.colors.orangeBackground
      : theme.colors.darkBlue,
  }),
);

const NavLinkWrapper = Wrapper.withComponent(Link);

const StyledIcon = styled(Icon)({
  [mobileQuery]: {
    fontSize: '1rem',
  },

  [laptopQuery]: {
    fontSize: '1.375rem',
  },
  [desktopQuery]: {
    fontSize: '1.375rem',
  },
});

const IconLabel = styled.label({
  paddingTop: '3px',
  fontSize: '0.875rem',
  color: theme.colors.mainText,
});

const IconWithLabelWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const IconWithLabel = ({ icon, label }) => (
  <IconWithLabelWrapper>
    {icon && (
      <StyledIcon size="lg" color={theme.colors.mainText} iconName={icon} />
    )}
    <IconLabel>{label}</IconLabel>
  </IconWithLabelWrapper>
);

const TabBarItem = ({
  icon,
  label,
  to,
  isActive,
  highlight,
  ...rest
}) => {
  if (to) {
    return (
      <NavLinkWrapper
        highlight={highlight}
        activeStyle={{ backgroundColor: theme.colors.orangeBackground }}
        partiallyActive={to !== '/'}
        to={to}
        {...rest}
      >
        <IconWithLabel isActive={isActive} icon={icon} label={label} />
      </NavLinkWrapper>
    );
  }

  return (
    <Wrapper {...rest}>
      <IconWithLabel icon={icon} label={label} />
    </Wrapper>
  );
};

export default TabBarItem;
